import type { ReactNode } from "react";

export function Section({
  children,
  max = "default",
}: {
  children: ReactNode;
  max?: "default" | "3xl" | "5xl";
}) {
  const maxClass =
    max === "3xl"
      ? "max-w-3xl"
      : max === "5xl"
        ? "max-w-5xl"
        : "max-w-[1500px]";
  return (
    <section className="relative py-16 md:py-24 px-5 sm:px-8 lg:px-12">
      <div className={`mx-auto ${maxClass}`}>{children}</div>
    </section>
  );
}

export function SectionHeading({
  eyebrow,
  navy,
  blue,
  sub,
  breakLine = false,
}: {
  eyebrow: string;
  navy: string;
  blue: string;
  sub?: string;
  breakLine?: boolean;
}) {
  return (
    <div className="mb-12 text-center">
      <div
        className="inline-flex items-center gap-2 mb-5 font-sans font-semibold uppercase"
        style={{ fontSize: "12px", letterSpacing: "0.2em", color: "#0B7CF2" }}
      >
        <span
          className="inline-block w-2 h-2 rounded-full"
          style={{ background: "#27DC5D" }}
        />
        {eyebrow}
      </div>
      <h2
        className="font-display font-extrabold"
        style={{
          fontSize: "clamp(34px, 4.6vw, 58px)",
          lineHeight: 1.02,
          letterSpacing: "-0.04em",
          color: "#071E61",
        }}
      >
        {breakLine ? (
          <>
            <span className="block">{navy}</span>
            <span className="block" style={{ color: "#0B7CF2" }}>
              {blue}
            </span>
          </>
        ) : (
          <>
            {navy} <span style={{ color: "#0B7CF2" }}>{blue}</span>
          </>
        )}
      </h2>
      {sub && (
        <p
          className="mx-auto mt-5 max-w-2xl"
          style={{ fontSize: "17px", lineHeight: 1.6, color: "#536B89" }}
        >
          {sub}
        </p>
      )}
    </div>
  );
}

export function Card({
  children,
  radius = 24,
}: {
  children: ReactNode;
  radius?: number;
}) {
  return (
    <div
      className="relative p-7 overflow-hidden"
      style={{
        borderRadius: `${radius}px`,
        background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBFF 100%)",
        border: "1px solid rgba(8,46,103,0.07)",
        boxShadow: "0 14px 40px rgba(8,46,103,0.08)",
      }}
    >
      {children}
    </div>
  );
}
